import { DataTableContainer } from 'src/components/DataTable/components/DataTableContainer/DataTableContainer';
import { DataTableContent } from 'src/components/DataTable/components/DataTableContent/DataTableContent';
import { DataTableHeader } from 'src/components/DataTable/components/DataTableHeader/DataTableHeader';
import { DataTableBody } from 'src/components/DataTable/components/DataTableBody/DataTableBody';
import { DataTableFooter } from 'src/components/DataTable/components/DataTableFooter/DataTableFooter';
import { DataTableRow } from 'src/components/DataTable/components/DataTableRow/DataTableRow';
import { DataTableCell } from 'src/components/DataTable/components/DataTableCell/DataTableCell';
import { DataTableColumn } from 'src/components/DataTable/components/DataTableColumn/DataTableColumn';
import { DataTableButton } from 'src/components/DataTable/components/DataTableButton/DataTableButton';
import { DataTableTitleBar } from 'src/components/DataTable/components/DataTableTitleBar/DataTableTitleBar';
import { DataTableToolbar } from 'src/components/DataTable/components/DataTableToolbar/DataTableToolbar';
import { DataTableProvider } from 'src/components/DataTable/components/DataTableProvider/DataTableProvider';
import { DataTableLink } from 'src/components/DataTable/components/DataTableLink/DataTableLink';
import { DataTableButtonLink } from 'src/components/DataTable/components/DataTableButtonLink/DataTableButtonLink';
import { DataTableLoading } from 'src/components/DataTable/components/DataTableLoading/DataTableLoading';
import { DataTableEmpty } from 'src/components/DataTable/components/DataTableEmpty/DataTableEmpty';
import { DataTableNoResults } from 'src/components/DataTable/components/DataTableNoResults/DataTableNoResults';
import { DataTableError } from 'src/components/DataTable/components/DataTableError/DataTableError';
import { DataTableTitle } from 'src/components/DataTable/components/DataTableTitle/DataTableTitle';
import { DataTableSummary } from 'src/components/DataTable/components/DataTableSummary/DataTableSummary';
import { DataTableSearch } from 'src/components/DataTable/components/DataTableSearch/DataTableSearch';
import { DataTableSingleSelectFilter } from 'src/components/DataTable/components/DataTableSingleSelectFilter/DataTableSingleSelectFilter';
import { DataTablePagination } from 'src/components/DataTable/components/DataTablePagination/DataTablePagination';
import { DataTableSelectionProvider } from 'src/components/DataTable/components/DataTableSelectionProvider/DataTableSelectionProvider';
import { DataTableSelectableCell } from 'src/components/DataTable/components/DataTableSelectableCell/DataTableSelectableCell';
import { DataTableSelectionColumnHeader } from 'src/components/DataTable/components/DataTableSelectionColumnHeader/DataTableSelectionColumnHeader';
import { DataTableSelectionActionBar } from 'src/components/DataTable/components/DataTableSelectionActionBar/DataTableSelectionActionBar';

export type {
  DataTableRef,
  DataTableSelectionRef,
} from 'src/components/DataTable/types/DataTableRef';

export const DataTable = {
  Container: DataTableContainer,
  Content: DataTableContent,
  Header: DataTableHeader,
  Body: DataTableBody,
  Footer: DataTableFooter,
  Row: DataTableRow,
  Cell: DataTableCell,
  Column: DataTableColumn,
  Button: DataTableButton,
  Provider: DataTableProvider,
  SelectionProvider: DataTableSelectionProvider,
  SelectableCell: DataTableSelectableCell,
  SelectionColumnHeader: DataTableSelectionColumnHeader,
  SelectionActionBar: DataTableSelectionActionBar,
  Link: DataTableLink,
  ButtonLink: DataTableButtonLink,
  Loading: DataTableLoading,
  Empty: DataTableEmpty,
  NoResults: DataTableNoResults,
  Error: DataTableError,
  TitleBar: DataTableTitleBar,
  Toolbar: DataTableToolbar,
  Title: DataTableTitle,
  Summary: DataTableSummary,
  Search: DataTableSearch,
  SingleSelectFilter: DataTableSingleSelectFilter,
  Pagination: DataTablePagination,
};
